<template lang="pug">
  .flex.text-16p2r.flex.tabHorizon.w-full
    .leftBlock.py-32.bg-grey-ef(class="min-w-248")
      .pl-20.pb-25()
        iCon.h-25.w-96.text-grey-77(:iconClass="'logo'" type="svg" )
      ul.text-left
        li.select-none(v-for="(item, index) in tabs"  :class="{'bg-white': activePage == index, 'text-main-0': activePage == index}")
          .py-20.px-25.cursor-pointer(@click.stop="onClickMenu(index)") {{item.list}} 
    .rightBlock(class="w-full")
      ul()
        li(v-for="(item, index) in tabs" v-show="activePage === index")
          slot(:name="'tab'+index")
      
    
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  name: 'TabHorizon',
  components: {
    Button,
  },
  props: {
    show: {
      type: Boolean,
      // required: true,
      default: false
    },
    slotLeft: String,
    slotRight: String,
    tabs: {
      type: Array,
      default() {
        return [{
          list: this.$t('__cookiesBanner.__asusCookiesNotice'),
          content: '',
        },
        {
          list: this.$t('__cookiesBanner.__essentialCookies'),
          content: '',
        },
        {
          list: this.$t('__cookiesBanner.__analyticsAndOtherCookies'),
          content: '',
        }]
      }
    },
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tabIndex :0
    };
  },
  mounted(){
  },
  computed: {
    activePage: {
      get() {
        return this.active;
      },
      set(val) {
        console.log('val', val);
        this.$emit('update:active', val);
      }
    },
    // privateIsOpen: {
    //   get() {
    //     return this.isOpen;
    //   },
    //   set(val) {
    //     this.$emit('update:isOpen', val);
    //   }
    // }
  },
  methods: {
    onClickMenu(i){
      this.activePage = i;
      // console.log('activePage', this.activePage)
      // this.$emit('tabIndex', i);
    }

  },
  watch:{
  }
};
</script>

<style lang="scss" scoped>

$popup-height: calc(100vh - 280px);
$popup-min-height: 440px;

.tabHorizon{
  // border:  solid 1px red;
  max-height: $popup-height;
  min-height: $popup-min-height;
  height: 100%;
}

</style>